/**
 * Offers page — add bundle products to cart from cards.
 */
class MobileOffersPage {
  /** @param {HTMLElement} root */
  constructor(root) {
    this.root = root;
    this.adding = false;
    this.bindAddToCart();
  }

  bindAddToCart() {
    this.root.addEventListener('click', async (event) => {
      const button = event.target.closest('.scp-card__atc--offerspage');
      if (!button || button.disabled || this.adding) return;

      event.preventDefault();
      event.stopPropagation();

      const variantId = button.dataset.variantId;
      if (!variantId) return;

      this.adding = true;
      button.disabled = true;
      button.classList.add('is-adding');
      const originalText = button.textContent?.trim() || 'Add to cart';
      button.textContent = 'Adding…';

      try {
        const cart = window.Theme?.storefrontCart;
        if (cart?.addVariantToCart) {
          await cart.addVariantToCart(variantId, 1);
          cart.openThemeCartDrawer?.();
        } else {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
          });
          if (!response.ok) throw new Error('Add failed');
          document.querySelector('theme-drawer#cart-drawer')?.open?.();
        }

        button.textContent = 'Added';
        button.classList.remove('is-adding');
        button.classList.add('is-added');
      } catch (error) {
        console.error(error);
        button.textContent = originalText;
        button.classList.remove('is-adding', 'is-added');
      } finally {
        this.adding = false;
        window.setTimeout(() => {
          button.disabled = false;
          button.classList.remove('is-added');
          if (button.textContent === 'Added') button.textContent = originalText;
        }, 1400);
      }
    });
  }
}

function initMobileOffersPage() {
  document.querySelectorAll('[data-mobile-offers-page]').forEach((root) => {
    if (root.dataset.offersBound === 'true') return;
    root.dataset.offersBound = 'true';
    new MobileOffersPage(root);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMobileOffersPage);
} else {
  initMobileOffersPage();
}

document.addEventListener('shopify:section:load', initMobileOffersPage);
